export default __webpack_public_path__ + "media/images/chevron-right-57eccae118d3a6169e0f9eff76d9f3e8.svg";